import React from 'react';
import { t } from 'utils/translates';

const Sandbox = () => (
  <div className="page page-panel">
    {t(
      'Вы можете использовать ссылки на любую страницу сервиса. Достаточно добавить <strong>персональный идентификатор</strong> <code class="text-nowrap">{urlParam}</code>. Например, тот кто перейдет по ссылке <code class="text-nowrap">{referralUrl}</code> и зарегистрируется будет так же записан за вами.',
      {
        urlParam: 111111,
        referralUrl: 22222222
      }
    )}
  </div>
);

export default Sandbox;



// WEBPACK FOOTER //
// ./src/lauoyts/Sandbox/index.js